import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    lng: 'sv',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    resources: {
      sv: {
        translation: {
          notFound: {
            heading: 'Spåra paket',
            messageOne: 'Sök efter ditt paket',
            messageTwo: 'Ditt paket-id kan hittas i det sms eller email du fått vid orderbekräftelse och är de 6 sista bokstäverna / siffrorna i länken.',
            input_placeholder: 'Ange ditt paket-id (6 bokstäver / siffror)'
          }
        }
      },
      en: {
        translation: {
          notFound: {
            heading: 'Tracking',
            messageOne: 'Search for your package',
            messageTwo: 'The package id can be found in the sms or email you received at order confirmation and is the last 6 digits / numbers in the link.',
            input_placeholder: 'Enter your package ID (6 letters / numbers)'
          }
        }
      },
      da: {
        translation: {
          notFound: {
            heading: 'Der opstod en fejl!',
            messageOne: 'Vi kunne desværre ikke finde din pakke.',
            messageTwo: 'Vi er her for at hjælpe dig!',
            input_placeholder: 'Angiv dit pakke-id (6 bogstaver / cifre)'
          }
        }
      }
    }
  })
  .then();

export default i18n;
